export default __webpack_public_path__ + "../staticImages/kuessendes_paar-260.png";